import CommentWrapper from './CommentWrapper'

const CommentGroup = ({id}) => (
  <div>
    <CommentWrapper id={id} />
  </div>
);

export default CommentGroup;
